import { FC } from 'react';

interface ShareBarProps {
    value: string; // e.g., "41%"
}

/**
 * Mini progress bar for share percentage
 * Clean, minimal design
 */
export const ShareBar: FC<ShareBarProps> = ({ value }) => {
    // Extract numeric percentage from string like "41%"
    const percentage = parseFloat(value?.replace('%', '') || '0');

    if (value === 'N/A' || isNaN(percentage)) {
        return <span className="text-sm text-gray-400">N/A</span>;
    }

    return (
        <div className="flex items-center gap-2.5">
            <div className="w-20 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div
                    className="h-full bg-slate-500 rounded-full transition-all duration-300"
                    style={{ width: `${Math.min(percentage, 100)}%` }}
                />
            </div>
            <span className="text-sm text-gray-700 tabular-nums">{value}</span>
        </div>
    );
};
